import css from './frame.module.scss';
import {FrameProps} from './frame.types';
import {isMobile} from 'react-device-detect';
import {CSSProperties} from 'react';
import {DeviceFrameset} from 'react-device-frameset';
import {frameDimensions} from '../../shared/frame-dimensions';
import 'react-device-frameset/styles/marvel-devices.min.css';

export const Frame = ({children}: FrameProps): JSX.Element => {
	const innerHeight = window.innerHeight;

	const styles: CSSProperties = {
		width: isMobile ? '100vw' : frameDimensions.width,
		height: isMobile ? innerHeight : frameDimensions.height,
	};

	const desktopFrame = (
		<DeviceFrameset device="iPhone X" width={frameDimensions.width} height={frameDimensions.height}>
			<div style={styles} className={css.app}>
				{children}
			</div>
		</DeviceFrameset>
	);

	const mobileFrame = (
		<div style={styles} className={css.app}>
			{children}
		</div>
	);

	const containerStyle: CSSProperties = {
		width: isMobile ? 'auto' : '100vw',
		height: isMobile ? 'auto' : '100vh',
	};

	return (
		<div style={containerStyle} className={css.container}>
			{isMobile ? mobileFrame : desktopFrame}
		</div>
	);
};
